import React from 'react';
import {connect} from 'react-redux';
import {Select, Modal, message} from 'antd';
import {
    setActiveSize,
    setGraph,
    setSchematicListElement,
    setSidebarVisibility,
    setSchematicDocument,
    clearSchematicListElements,
    setLogOut,
    createDraft, setLoader, removeLoader
} from "../../store/Schematic_store/actions";
import styles from './Header.module.css'
import {ExclamationCircleOutlined} from '@ant-design/icons';
import EditorBtn from "../Components/Buttons/EditorBtn/EditorBtn";
import btnStyle from "../Components/Buttons/EditorBtn/EditorBtnCss.module.css";
import {Link} from "react-router-dom";
import {saveAs} from 'file-saver';
import ImportModal from '../Components/ImportModal/ImportModal';
import ExportModal from '../Components/ExportModal/ExportModal';
import {withRouter} from 'react-router';
import GraphFactoryService from "../services/GraphFactoryService";
import AppService from "../services/AppService";

const {Option} = Select;
const {confirm} = Modal;

const showMessage = (typeofMessage, content) => {
    message[typeofMessage](content)
};

class Header extends React.PureComponent {

    constructor(props) {
        super(props);
        this.gridSizes = [1, 5, 10];
        this.state = {
            visibleModalImport: false,
            visibleModalExport: false,
        }
    }

    handleSizeChange = (size) => {
        const {changeSize} = this.props;
        changeSize(size);
    };

    packageSymbols = () => {
        const {graph} = this.props;
        if (graph.hasSymbolsWithManualPackageName()) {
            confirm({
                title: 'Refresh manually set package names?',
                icon: <ExclamationCircleOutlined/>,
                content: '',
                okText: 'Yes',
                cancelText: 'No',
                onOk: () => {
                    graph.package(true);
                },
                onCancel: () => {
                    graph.package(false);
                }
            });
        } else {
            graph.package(false);
        }
    };

    checkUnsavedChanges = (onProceed) => {
        const {graph} = this.props;
        if (graph.isDirty()) {
            confirm({
                title: 'All unsaved changes will be lost. Would you like to save them?',
                icon: <ExclamationCircleOutlined/>,
                content: '',
                okText: 'Save',
                cancelText: 'No, continue without saving',
                onOk: () => {
                    this.showModal('export');
                },
                onCancel() {
                    onProceed();
                }
            });
        } else {
            onProceed();
        }
    };

    showModal = (type) => {
        switch (type) {
            case 'import': {
                this.setState({visibleModalImport: true});
                break;
            }
            case 'export': {
                this.setState({visibleModalExport: true});
                break;
            }
        }
    };

    printWrapper = () => {
        const {setLoader, removeLoader} = this.props;
        setLoader('Preparing for print...')
        setTimeout(() => {
            this.printPreview();
            removeLoader('Preparing for print...');
        })
    };

    printPreview = () => {
        const {gridStep, schematicDocument, graph, activeSchematicType} = this.props;
        const wrapper = document.createElement('div');
        const printGraph = GraphFactoryService.initEditor(wrapper, gridStep);
        const json = AppService.getUpdatedSchematicJson(graph, schematicDocument);
        printGraph.recreatePages(json, activeSchematicType);
        printGraph.transformToOneSheet();
        const preview = new window.mxPrintPreview(printGraph, null, null, null, 0, 0, null, 'Schematic Print');
        const writeHead = preview.writeHead;
        preview.autoOrigin = false;
        preview.writeHead = function (doc) {
            /**
             * This code need to reset body margin, which breaks print window
             */
            writeHead.apply(this, arguments);
            doc.writeln('<style type="text/css">');
            doc.writeln('  body { margin: 0 }');
            doc.writeln('</style>');
        };
        preview.print();
        printGraph.destroy();
    };
    handleUndo = () => {
        const {graph} = this.props;
        graph.manager.undo();
    };

    handleRedo = () => {
        const {graph} = this.props;
        graph.manager.redo();
    };


    exportNetlist = () => {
        const {graph} = this.props;
        try {
            const blob = new Blob([graph.generateNetList()], {type: "text/plain;charset=utf-8"});
            saveAs(blob, 'Netlist.txt');
        } catch (e) {
            showMessage('error', e.message);
        }
    };

    onNewSchematic = () => {
        const {createDraft} = this.props;
        this.checkUnsavedChanges(() => {
            createDraft();
        })
    };

    onImport = () => {
        this.checkUnsavedChanges(() => {
            this.showModal('import');
        })
    };

    navigateLink = (url) => {
        const {graph, setSchematicDocument, history} = this.props;
        this.checkUnsavedChanges(() => {
            graph.destroy();
            setSchematicDocument(null);
            history.push(url);
        });
        /**
         * Destroy graph to clear listeners
         */

    };


    render() {
        const {gridStep, logOut, graph} = this.props;
        const {visibleModalImport, visibleModalExport} = this.state;
        return (
            <div>
                <div className={styles.header_title}>
                    <a href="#"><img src="img/logo_256.png" className={styles.logo} alt="Logo"/></a>
                </div>
                <div>
                    <div className={styles.header_right_top}>
                        <div className={styles.cssmenu}>
                            <ul>
                                <li className={`${styles.active} ${styles.has_sub}`}><a
                                    href='#'><span>File</span></a>
                                    <ul>
                                        <li onClick={this.onNewSchematic}><a
                                            href='#'><span>New schematic</span></a></li>
                                        <li onClick={() => this.showModal('export')}><a
                                            href='#'><span>save</span></a></li>
                                        <li className={styles.import_file}
                                            onClick={this.onImport}><a
                                            href='#'>load</a></li>
                                        <li
                                            onClick={this.exportNetlist}><a
                                            href='#'>Export as netlist</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <Link to='#'
                                          onClick={() => this.navigateLink('/account/projects')}>Projects</Link>
                                </li>
                                <li>
                                    <Link to='#' onClick={() => this.navigateLink('/account/info')}>Account</Link>
                                </li>

                                <li>
                                    <Link onClick={logOut} to={'/home/login'}
                                    >Log Out</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.header_btm}>
                        <div className={styles.graph_settings}>
                            <EditorBtn tn title={'Print'} config={{
                                cssClass: `${btnStyle.geSprite_print}`,
                                active: false
                            }} handleClick={this.printWrapper}/>
                            <EditorBtn title={'Undo'} config={{
                                cssClass: `${btnStyle.geSprite_undo}`,
                                active: false
                            }} handleClick={this.handleUndo}/>
                            <EditorBtn title={'Redo'} config={{
                                cssClass: `${btnStyle.geSprite_redo}`,
                                active: false
                            }} handleClick={this.handleRedo}/>
                            <EditorBtn title={'Package'} config={{
                                cssClass: `${btnStyle.geSprite_package}`,
                                active: false
                            }} handleClick={this.packageSymbols}/>
                            <Select value={gridStep} style={{width: 55}}
                                    size="small"
                                    title="Grid step"
                                    onChange={this.handleSizeChange}>
                                {this.gridSizes.map((size) => {
                                    return (
                                        <Option key={size} value={size}>{size}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                </div>

                <ExportModal graph={graph}
                             onClose={(() => this.setState({visibleModalExport: false}))}
                             visible={visibleModalExport}/>
                <ImportModal onClose={() => this.setState({visibleModalImport: false})}
                             visible={visibleModalImport}/>
            </div>
        );
    }
}

function

mapStateToProps({schematicReducers: {activeSchematicType, schematicDocument, elementsDraggable, gridStep, graph, schematicList, schematicPages}}) {
    return {
        activeSchematicType,
        elementsDraggable,
        schematicDocument,
        gridStep,
        schematicList,
        schematicPages,
        graph: graph.value
    }
}

function

mapDispatchToProps(dispatch) {
    return {
        setLoader: (loader) => {
            dispatch(setLoader(loader));
        },
        removeLoader: (loader) => {
            dispatch(removeLoader(loader))
        },
        setGraphToStore: (graph) => {
            dispatch(setGraph(graph))
        },
        changeSize: (gridStep) => {
            dispatch(setActiveSize(gridStep))
        },
        setSchematicElement: (schematicUpdated) => {
            dispatch(setSchematicListElement(schematicUpdated))
        },
        setSidebarVisibility: (value) => {
            dispatch(setSidebarVisibility(value))
        },
        setSchematicDocument: (schematicDocument) => {
            dispatch(setSchematicDocument(schematicDocument))
        },
        clearSchematicListElements: () => {
            dispatch(clearSchematicListElements())
        },
        logOut: () => {
            dispatch(setLogOut())
        },
        createDraft: () => {
            dispatch(createDraft());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)

(
    withRouter(Header)
)
;
